import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import {
  cloneValue,
  expectObject,
  readBoolean,
  readOptionalNumber,
  splitKnown,
} from "../utils";
import { ProductVersionShippingPriceModel } from "./ProductVersionShippingPriceModel";

export class ProductVersionShippingPriceBracketModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    orderBelow: { label: "Order Below", fieldType: "number", allowNull: true },
    distributorOnly: { label: "Distributor Only", fieldType: "boolean" },
    adminOnly: { label: "Admin Only", fieldType: "boolean" },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  orderBelow!: number | null;
  price!: ProductVersionShippingPriceModel | null;
  distributorOnly!: boolean;
  adminOnly!: boolean;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("orderBelow", null);
    this.defineObservableValue("price", null);
    this.defineObservableValue("distributorOnly", false);
    this.defineObservableValue("adminOnly", false);
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product shipping price bracket");
    this.orderBelow = readOptionalNumber(source, "orderBelow");
    this.price =
      source.price &&
      typeof source.price === "object" &&
      !Array.isArray(source.price)
        ? new ProductVersionShippingPriceModel().restore(source.price)
        : new ProductVersionShippingPriceModel();
    this.distributorOnly = readBoolean(source, "distributorOnly", false);
    this.adminOnly = readBoolean(source, "adminOnly", false);
    this.extra = splitKnown(source, [
      "orderBelow",
      "price",
      "distributorOnly",
      "adminOnly",
    ]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.orderBelow === null ? {} : { orderBelow: this.orderBelow }),
      ...(this.price && Object.keys(this.price.save()).length > 0
        ? { price: this.price.save() }
        : {}),
      ...(this.distributorOnly ? { distributorOnly: true } : {}),
      ...(this.adminOnly ? { adminOnly: true } : {}),
    };
  }
}
